import * as z from 'zod';

export const phoneNumberSchema = z
  .string()
  .refine(value => /(070|080|090)\d{8}$/.test(value), {
    message: '電話番号は11文字の半角数字で入力してください。'
  });
